<template>
<div class="HomeSetting padding-20 bgc box-shadow">
    <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="基本信息" name="baseinfo">
            <baseinfo ref="baseinfo" @getView="_getView"></baseinfo>
        </el-tab-pane>
        <el-tab-pane label="背景设置" name="backgroundinfo">
            <backgroundinfo ref="backgroundinfo"></backgroundinfo>
        </el-tab-pane>
        <el-tab-pane label="客服设置" name="serviceinfo">
            <serviceinfo ref="serviceinfo" @getView="_getView"></serviceinfo>
        </el-tab-pane>
        <el-tab-pane label="管理员维护" name="managerinfo">
            <managerinfo ref="managerinfo"></managerinfo>
        </el-tab-pane>
        <el-tab-pane label="分享海报" name="shareinfo">
            <shareinfo ref="shareinfo"></shareinfo>
        </el-tab-pane>
    </el-tabs>
</div>
</template>

<script>
import Baseinfo from 'views/brandBusiness/systemSetting/homeSetting/components/baseinfo.vue'
import Serviceinfo from 'views/brandBusiness/systemSetting/homeSetting/components/serviceinfo.vue'
import Shareinfo from 'views/brandBusiness/systemSetting/homeSetting/components/shareinfo.vue'
import Backgroundinfo from 'views/brandBusiness/systemSetting/homeSetting/components/backgroundinfo.vue'
import Managerinfo from 'views/brandBusiness/systemSetting/homeSetting/components/managerinfo.vue'
import {getHomePageInfoByHostRole} from 'api/brandBusiness'
import {mapGetters, mapActions} from 'vuex'

export default {
    name: 'HomeSetting',
    data() {
        return {
            activeName: 'baseinfo',
            item: {}
        }
    },
    mounted() {
        this._getView()
    },
    methods: {
        handleClick() {
            switch (this.activeName) {
                case 'baseinfo':
                    this.$refs.baseinfo.init(this.item)
                    break
                case 'backgroundinfo':
                    this.$refs.backgroundinfo.init(this.item)
                    break
                case 'serviceinfo':
                    this.$refs.serviceinfo.init(this.item)
                    break
                case 'managerinfo':
                    this.$refs.managerinfo.init()
                    break
                case 'shareinfo':
                    this.$refs.shareinfo.init()
                    break
            }
        },
        _getView() {
            this.setLoading(true)
            getHomePageInfoByHostRole({
                data: {},
                success: data => {
                    data.data.ischangehead = 0
                    data.data.smscode = ''
                    this.item = data.data
                    this.handleClick()
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        Baseinfo, Serviceinfo, Shareinfo, Backgroundinfo, Managerinfo
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.HomeSetting {
}
</style>
